import _ from 'lodash';
import update from 'react-addons-update';
import Cookies from 'js-cookie';
import { findById as LEGACY_findById } from 'core/utils/legacyUtils';
import { EXAM_QUESTION_TYPES } from 'edrolo/constants/QuestionTypes';

const concatArrays = (anArray, anotherArray) => anArray.concat(anotherArray);

const Utils = {
  addUpMarksAvailable(data) {
    // Nested reduce! Whee!
    return data.sections.reduce(
      (runningExamTotal, section) =>
        runningExamTotal + Utils.addUpSectionMarksAvailable(section),
      0
    );
  },

  addUpSectionMarksAvailable(section) {
    if (!(section && section.flatQuestions)) {
      return 0;
    }
    const sectionMarks = section.flatQuestions.reduce(
      (runningTotal, question) => runningTotal + Number(question.marks),
      0
    );
    return sectionMarks;
  },

  flattenChildren(obj) {
    let flattenedChildren = [];
    if (obj.children) {
      obj.children.forEach((child) => {
        child.parent = obj;
      });
      flattenedChildren = obj.children
        .map(Utils.flattenChildren)
        .reduce(concatArrays, []);
    }
    const objAndChildren = [obj].concat(flattenedChildren);
    return objAndChildren;
  },

  flattenSectionData(sectionData) {
    const flatSectionData = update(sectionData, {
      flatQuestions: {
        $set: sectionData.questions
          .map(Utils.flattenChildren)
          .reduce(concatArrays, []),
      },
    });
    flatSectionData.flatQuestions.forEach((question) => {
      question.fullSerial = Utils.fullQuestionSerial(question);
    });
    return flatSectionData;
  },

  fullQuestionSerial(question) {
    let serial = question.serial;
    if (question.parent) {
      serial = `${Utils.fullQuestionSerial(question.parent)}.${
        question.serial
      }`;
    }
    return serial;
  },

  isQuestionSaved(question, responses, recursive) {
    // Checks whether a response has been submitted  to this question
    // If `recursive` is true, recursively checks whether all sub-questions are saved
    let isSaved;
    if (recursive && question.children && question.children.length) {
      isSaved = question.children.every((child) =>
        Utils.isQuestionSaved(child, responses)
      );
    } else {
      const response = LEGACY_findById(responses, question.id, 'question');
      isSaved = !!(response && response.your_answer);
    }
    return isSaved;
  },

  getResourceQuestionMap(section) {
    // Produce an object of the form {234:845, 547:234, ...}
    // Where the keys are resourceIds, and the values are the ids of the first
    // question to reference that resource.
    return section.flatQuestions
      .filter((question, i, questions) => !!question.resource)
      .map((questionWithResource, j) => ({
        resourceId: questionWithResource.resource.id,
        questionId: questionWithResource.id,
      }))
      .reduceRight((previousValue, currentValue, index, array) => {
        previousValue[currentValue.resourceId] = currentValue.questionId;
        return previousValue;
      }, {});
  },

  // Find the root question in a question hierarchy
  findRootQuestion(question) {
    if (!_.isEmpty(question.parent)) {
      return Utils.findRootQuestion(question.parent);
    }
    return question;
  },

  isSelfMarkedQuestion(question) {
    return [
      EXAM_QUESTION_TYPES.TEXT,
      EXAM_QUESTION_TYPES.COMPLEX,
      EXAM_QUESTION_TYPES.WORKED,
    ].includes(question.question_type);
  },

  isAutoMarkedQuestion(question) {
    return !Utils.isSelfMarkedQuestion(question);
  },

  EXAM_MODE: {
    OFFLINE: 1,
    ONLINE: 0,
  },

  setExamModeCookie(examId, mode) {
    const examModeJson = Cookies.get('exam_mode');
    let examModeData = {};
    if (examModeJson) {
      try {
        examModeData = JSON.parse(examModeJson);
      } catch (e) {
        console.error('Invalid exam mode cookie');
      }
    }

    examModeData[examId] = mode;
    Cookies.set('exam_mode', JSON.stringify(examModeData), { path: '/' });
  },
  getExamModeCookie(examId) {
    const examModeJson = Cookies.get('exam_mode');
    let examModeData = {};
    if (examModeJson) {
      try {
        examModeData = JSON.parse(examModeJson);
      } catch (e) {
        console.error('Invalid exam mode cookie');
      }
    }

    return examModeData[examId] || Utils.EXAM_MODE.ONLINE;
  },

  // TODO This would make a nice node module; kinda like pluralize (and/or)
  csl(list, conjunction = 'and') {
    if (list.length <= 1) {
      return list[0] || '';
    }

    const str = list.slice(0, -1).join(', ');
    const last = list[list.length - 1];

    return [str, conjunction, last].join(' ');
  },
};

export default Utils;
